// src/store/index.ts
import { legacy_createStore as createStore, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage
import storageSession from "redux-persist/lib/storage/session"; // sessionStorage

import cartReducer from "./reducers/cartReducer.ts";
import authReducer from "./reducers/adminReducer.ts";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__?: () => any;
  }
}

// cart -> localStorage
const cartPersistConfig = {
  key: "cart",
  storage,
};

// auth -> sessionStorage
const authPersistConfig = {
  key: "auth",
  storage: storageSession,
};

const rootReducer = combineReducers({
  cart: persistReducer(cartPersistConfig, cartReducer),
  auth: persistReducer(authPersistConfig, authReducer),
});

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export default store;
